import { useState, useEffect } from "react"

/**
 * Manages the active lens state with localStorage persistence.
 */
export default function useLensState() {
  const [activeLens, setActiveLens] = useState(() => {
    const stored = window.localStorage?.getItem("insightsPortal.activeLens")
    return stored || "domain"
  })

  useEffect(() => {
    try {
      window.localStorage?.setItem("insightsPortal.activeLens", activeLens)
    } catch (_) {
      // ignore
    }
  }, [activeLens])

  return [activeLens, setActiveLens]
}
